export default {
  LOCATIONS_LIST: "Liste des applications",
  ADD_LOCATION: "Ajouter une application",
  LOCATION_ADDED: "Application ajouté",
  LOCATIONS_UPDATED: "Application modifié",
  EDIT_LOCATION: "Modifier cet application",
  DELETE_THIS_LOCATION: "Supprimer cet application?",
  LOCATION_DELETED: "Application supprimé",
  VIEW_LOCATION: "Application",
  NONE: "Aucune",
};
